var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M546.801 193.624C349.334 193.624 206.091 220.037 124.407 272.842C42.6703 325.683 0 429.611 0 584.7C0 683.586 46.1403 768.436 140.337 839.239C234.498 910.027 361.716 945.451 522.854 945.451C683.993 945.451 812.569 912.853 894.285 847.66C975.966 782.479 1024 699.324 1024 598.196V79C907.211 155.419 766.893 193.624 546.801 193.624ZM278.328 685.197C295.316 697.996 319.604 704.393 351.192 704.393C397.616 704.393 431.116 689.938 451.696 661.027L486.156 681.642C459.832 721.458 414.845 741.365 351.195 741.365C306.686 741.365 272.348 732.24 248.179 713.99C224.008 695.745 211.923 670.506 211.923 638.278V474.756C211.923 442.526 224.008 417.29 248.179 399.04C272.346 380.794 306.686 371.67 351.195 371.67C411.976 371.67 457.199 391.813 486.871 432.101L454.568 452.007C436.383 423.096 401.921 408.641 351.195 408.641C319.607 408.641 295.318 415.038 278.33 427.835C261.342 440.635 252.843 456.275 252.843 474.756V638.278C252.841 656.76 261.34 672.399 278.328 685.197ZM812.075 638.276C812.075 670.976 800.586 696.337 777.613 714.347C754.643 732.356 721.143 741.365 677.112 741.365C632.606 741.365 597.548 731.768 571.942 712.567C546.338 693.373 533.538 667.658 533.538 635.43C533.538 594.669 545.5 565.754 569.428 548.693C593.359 531.629 630.45 523.096 680.701 523.096C741.48 523.096 771.872 506.036 771.872 471.908C771.872 454.371 763.256 439.444 746.032 427.119C728.799 414.798 704.63 408.635 673.525 408.635C628.057 408.635 595.034 423.8 574.458 454.135L539.283 433.52C566.565 392.283 611.311 371.664 673.527 371.664C718.033 371.664 752.252 380.788 776.185 399.034C800.113 417.284 812.079 442.52 812.079 474.75V638.276H812.075Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.5 575.349C582.472 585.54 574.455 605.567 574.455 635.425C574.455 654.383 583.547 670.617 601.734 684.125C619.919 697.637 645.045 704.386 677.112 704.386C708.219 704.386 731.792 698.108 747.82 685.544C763.857 672.989 771.87 657.229 771.87 638.269V540.867C753.208 553.665 722.813 560.061 680.7 560.061C641.935 560.061 614.537 565.159 598.5 575.349Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.0000229706,
    y1: 944.768,
    x2: 1067.06,
    y2: 163.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#375B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#665F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B1539A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#EA476F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F86624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.0000229706,
    y1: 944.768,
    x2: 1067.06,
    y2: 163.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#375B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#665F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B1539A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#EA476F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F86624"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaAppIcon);
export default __webpack_public_path__ + "static/media/ca-app-icon.f4d1847c00905da7893f1a7885298986.svg";
export { ForwardRef as ReactComponent };